import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      video={videos.mlbtv.videoUrl}
      title="Watch baseball live without cable"
      subtitle="Catch live games all season long"
      networkSet="baseball"
      league="mlb"
      showRSN={true}
    />
  )
}
